import React from "react";
import "../../styles/Modals.css";
import ClosedIcon from "../../icons/ClosedIcon";
import ApprovedVendorIcon from "../../icons/ApprovedVendorIcon";
import { translateLabel, translateText, useTranslationSnapshot } from "./../../translations/runtime";


function ApproveModal({ error, isSubmitting = false, onClose, onConfirm }) {
  useTranslationSnapshot();
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="modal-close" onClick={onClose}>
          <ClosedIcon />
        </div>

        <div className="modal-icon-circle modal-icon-circle-green">
          <ApprovedVendorIcon />
        </div>

        <div className="modal-title">{translateLabel("txt_admin_approve_vendor", "Approve Vendor")}</div>
        <div className="modal-subtitle">
          Are you sure you want to approve this vendor. Their storefront will become publicity visible on the marketplace.
        </div>

        {error && <div className="modal-error">{translateText(error)}</div>}

        <div className="modal-footer">
          <button
            className="modal-btn-cancel"
            disabled={isSubmitting}
            onClick={onClose}
          > {translateLabel("btn_cancel", "Cancel")} </button>
          <button
            className="modal-btn-approve"
            disabled={isSubmitting}
            onClick={onConfirm}
          >
            {isSubmitting ? translateLabel("txt_admin_approving", "Approving...") : translateLabel("txt_admin_approve_vendor", "Approve Vendor")}
          </button>
        </div>

      </div>
    </div>
  );
}

export default ApproveModal;
